/**
 * Shared cost-code category data for the CTC view.
 *
 * Cost codes are 5+ characters formatted as `NN-XXX`; the leading two digits
 * identify the category (Labor, Materials, etc.). Both `CATEGORIES` (an
 * ordered list used to render the cost-code table in a stable category order)
 * and `getCategoryByCode` (lookup used by the Estimator/HistoryDialog) read
 * from the same source so the mapping cannot drift.
 */

export interface CostCodeCategory {
  category: string;
  code: string;
}

export const CATEGORIES: CostCodeCategory[] = [
  { category: 'Labor', code: '10' },
  { category: 'Materials', code: '20' },
  { category: 'Equip Rental', code: '30' },
  { category: 'Permits Rental', code: '70' },
  { category: 'Subcontractors', code: '40' },
  { category: 'Other', code: '50' },
];

const CODE_TO_CATEGORY: Record<string, string> = CATEGORIES.reduce<
  Record<string, string>
>((acc, { code, category }) => {
  acc[code] = category;
  return acc;
}, {});

export const getCategoryByCode = (
  costCode: string | undefined,
): string | undefined =>
  costCode ? CODE_TO_CATEGORY[costCode.slice(0, 2)] : undefined;

export const LABOR_CATEGORY = 'Labor';
